import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

/** Both searches ignore shorter terms (GAME_SEARCH_MIN_LENGTH in the backend, Betaxis alike). */
export const MIN_LENGTH = 2;

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 800,
  letterSpacing: 0.4,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
}));
